// This service handles communication with TheDogAPI

const DOG_API_KEY = process.env.REACT_APP_DOG_API_KEY
const DOG_API_URL = "https://api.thedogapi.com/v1"

export async function getDogBreedInfo(breedName) {
  try {
    // Search for the breed by name
    const searchResponse = await fetch(`${DOG_API_URL}/breeds/search?q=${encodeURIComponent(breedName)}`, {
      headers: {
        "x-api-key": DOG_API_KEY,
      },
    })

    if (!searchResponse.ok) {
      throw new Error(`Dog API search error: ${searchResponse.status}`)
    }

    const breeds = await searchResponse.json()

    // If no breeds found, return null
    if (!breeds || breeds.length === 0) {
      console.log(`No breed information found for: ${breedName}`)
      return null
    }

    // Get the first (most relevant) breed match
    const breed = breeds[0]

    // Extract relevant information
    return {
      id: breed.id,
      name: breed.name,
      temperament: breed.temperament,
      lifeSpan: breed.life_span,
      breedGroup: breed.breed_group,
      breedFor: breed.bred_for,
      weight: {
        metric: breed.weight?.metric,
        imperial: breed.weight?.imperial,
      },
      height: {
        metric: breed.height?.metric,
        imperial: breed.height?.imperial,
      },
    }
  } catch (error) {
    console.error("Error fetching dog breed info:", error)
    // Return null instead of throwing to prevent app crashes
    return null
  }
}

